<template>
  <div class="om-hairline-top" :class="b({ fixed, auto })" :style='innerStyle'>
    <slot />
  </div>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'tabbar',

  data() {
    return {
      items: []
    };
  },

  props: {
    value: Number,
    fixed: {
      type: Boolean,
      default: true
    },
    auto: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    items() {
      this.setActiveItem();
    },
    value() {
      this.setActiveItem();
    }
  },

  computed: {
    innerStyle: function () {
      return {
        position: this.fixed ? 'fixed' : 'inherit'
      }
    }
  },

  methods: {
    setActiveItem() {
      this.items.forEach((item, index) => {
        item.active = index === this.value;
      });
    },
    onChange(active) {
      this.$emit('input', active);
      this.$emit('change', active);
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/tabbar/index.vue